/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";

/**
 * Group of the gate log: the icon and the title that name what was registered,
 * followed by its rows.
 */
const GateLogGroup = ({Icon, title, children}) => {
    return (
        <div className={"row mt-3"}>
            <div className={"col-12"}>
                <div className={"border-radius-8px background-shades-50 border-full-shades-100 p-3"}>
                    <div className={"d-flex align-items-center mb-2"}>
                        <div className={"background-shades-100 border-radius-8px mr-2 p-1"}>
                            <Icon width={40} height={40}/>
                        </div>
                        <p className={"ibl-font-w-600 fs-14px"}>{title}</p>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default GateLogGroup;
